import { FC } from 'react'

import { trans } from '@/helpers/trans'

import { ExchangeButton } from './subcomponents/ExchangeButton/ExchangeButton'

import './ExchangeShiftOptions.scss'


interface ExchangeShiftOptionsProps {
    onOfferShiftClick: () => void
    onChooseEmployeeClick: () => void
}

export const ExchangeShiftOptions: FC<ExchangeShiftOptionsProps> = ({
    onOfferShiftClick,
    onChooseEmployeeClick,
}) => (
    <div className="exchange-shift-options">
        <h1 className="exchange-shift-options__title">
            {trans('pages.exchanges.chooseExchangeMethod')}
        </h1>
        <ExchangeButton
            text={trans('pages.exchanges.offerShift')}
            onClick={onOfferShiftClick}
        />
        <ExchangeButton
            text={trans('pages.exchanges.chooseEmployee')}
            onClick={onChooseEmployeeClick}
        />
    </div>
)
